import { render, staticRenderFns } from "./dishesSize.vue?vue&type=template&id=2c5bf1a8&scoped=true&"
import script from "./dishesSize.vue?vue&type=script&lang=js&"
export * from "./dishesSize.vue?vue&type=script&lang=js&"
import style0 from "./dishesSize.vue?vue&type=style&index=0&id=2c5bf1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5bf1a8",
  null
  
)

export default component.exports